import { useMemo } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { isNumber } from 'lodash';
import { useMetricColor } from '../../../utilities/ColorUtilities';
/* eslint-disable react/prop-types */

const useBarChartStyles = makeStyles({
    root: {
        display: 'block',
        width: '100%',
    },

    bar: {
        display: 'inline-block',
        height: '14px',
        minWidth: '2px',

        '&:hover': {
            opacity: 0.6,
        },
    },
});

/**
 * Note, this functionality was ported from the portal/ui app. This column seems tailored to
 * the Path Log hop delay column. If you're looking for stacking bar charts, this is not the
 * place to look, and you'll likely need to implement your own or improve this column's
 * featureset.
 *
 * @param {Object} props
 */
function BarChart(props) {
    const { metricColor, total } = props;
    const classes = useBarChartStyles(props);
    const backgroundColor = useMetricColor(metricColor);

    const barStyles = useMemo(
        () => ({
            width: `${total * 100}%`,
            backgroundColor,
        }),
        [backgroundColor, total]
    );

    return isNumber(total) && total > 0 && total <= 1 ? (
        <div className={classes.root}>
            <div className={classes.bar} style={barStyles}>
                {' '}
            </div>
        </div>
    ) : null;
}

export function barChartRenderer(row, column) {
    const { metricColor, mapper } = column;
    const total = mapper(row, column) || 0;

    return <BarChart metricColor={metricColor} total={total} />;
}
